import { Action } from '@agile-actors/actions/js';

const namespaceAction = Action('@@UI/SNACKBAR');

const openSnackbar = namespaceAction('OPEN');
const closeSnackbar = namespaceAction('CLOSE');

export { openSnackbar, closeSnackbar };
